module.exports = __webpack_public_path__ + "img/diamonds-3-new-3.c5a6f259.svg";